// extracted by mini-css-extract-plugin
module.exports = {"content":"MarkdownViewer_content__L_UYV","consoleEmbeddedMarkdown":"MarkdownViewer_consoleEmbeddedMarkdown__1VPty"};